import React, { useState, useRef, useEffect } from 'react';
import { Button, Form, Card } from 'react-bootstrap';
import * as Service from '@app/services/apifp';
import { toast } from 'react-toastify';
import Resizer from 'react-image-file-resizer';
import ClockLoader from 'react-spinners/ClockLoader';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import Modal from 'react-bootstrap/Modal';
import Avatar from '@mui/material/Avatar';
import Select from 'react-select';

const customStyles = {
  overlay: { zIndex: 9999 }
};

const allowedTypes = ['image/jpeg', 'image/jpg'];

export default function Uploader(props) {
  const [file, setFile] = useState(null);
  const [state, setState] = useState(null);
  // const [images, setImages] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false); // 🛠 ค่าเริ่มต้นเป็น false
  const [isLoading, setLoading] = useState(false);
  const [selectedReason, setSelectedReason] = useState(null);

  const [index, setIndex] = useState(-1);
  const currentImage = props.images[index];
  const nextIndex = (index + 1) % props.images.length;
  const nextImage = props.images[nextIndex] || currentImage;
  const prevIndex = (index + props.images.length - 1) % props.images.length;
  const prevImage = props.images[prevIndex] || currentImage;

  const handleClick = (index) => {
    console.log("📌 เปิด Lightbox ที่ index:", index);
    // console.log(currentImage[0]);
    setIndex(index);
  };
  const handleClose = () => setIndex(-1);
  const handleMovePrev = () => setIndex(prevIndex);
  const handleMoveNext = () => setIndex(nextIndex);

  const [showMd, setShowMd] = useState(false);

  useEffect(() => {
    console.log("📌 Uploader ได้รับข้อมูล:", props.item);
    if (props.item !== null) {
      setIndex(-1);
      setState(props.item);
    }
  }, [props.item]);

  useEffect(() => {
    const checkAdminStatus = async () => {
      try {
        const result = await Service.checkAdmin();
        console.log("🔍 ตรวจสอบค่า isAdmin จาก API:", result.value);
        setIsAdmin(result.value);
      } catch (error) {
        console.error("🚨 ตรวจสอบสิทธิ์แอดมินล้มเหลว:", error);
        setIsAdmin(false); // ถ้าเกิด Error ให้ถือว่าไม่ใช่แอดมิน
      }
    };

    checkAdminStatus();
  }, []);

  const selectImage = async (e) => {
    e.preventDefault();
    const _file = e.target.files[0];

    if (!_file) {
      toast.error("⚠️ กรุณาเลือกไฟล์ภาพ!");
      return;
    }

    if (!allowedTypes.includes(_file.type)) {
      toast.error("⚠️ อนุญาตเฉพาะไฟล์ JPG/JPEG เท่านั้น!");
      return;
    }

    try {
      setFile(_file);
      let base64 = await convertToBase64(_file);
      setState((prevState) => ({
        ...prevState,
        b64: base64,
      }));
      setShowMd(true);
    } catch (error) {
      console.error("🚨 Error converting image:", error);
      toast.error("🚨 เกิดข้อผิดพลาดในการแปลงรูปภาพ");
    }
  };


  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => resolve(fileReader.result);
      fileReader.onerror = (error) => reject(error);
    });
  };

  const handleUploadConfirm = async () => {
    if (!file) {
      toast.error("⚠️ ยังไม่มีรูปที่เลือก");
      return;
    }
    setShowMd(false);
    await uploadImage(file);
  };


  const uploadImage = async (file) => {
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("image", file);
      formData.append("typeid", state?.TYPE);
      formData.append("shopId", props.item?.SHOP_ID);
      formData.append("reasonid", props.item?.REMARK);

      // console.log("ส่งข้อมูลไป API:", formData);

      const result = await Service.uploadImage(formData);

      if (result.result === "SUCCESS") {
        // toast.success("อัปโหลดรูปสำเร็จ!");
        props.onUpdate({
          ...props.item,
          DOC_PATH: result.img_path,
          STATUS: ""
        });
      } else {
        toast.error("อัปโหลดล้มเหลว");
      }
    } catch (error) {
      console.error("Upload Error:", error);
      toast.error("อัปโหลดผิดพลาด");
    }
    setLoading(false);
  };

  // const handleUpdateStatus = async (status) => {
  //   setLoading(true);
  //   const result = await Service.updateDocumentStatus(props.item?.SHOP_ID, state?.TYPE, status, props.item?.REMARK );
  //   console.log(result);
  //   if (result.success) {
  //     toast.success(result.message);
  //     props.onUpdate({ ...props.item, STATUS: status === "reject" ? "R" : "" });
  //   } else {
  //     toast.error(result.message);
  //   }

  //   setLoading(false);
  // };
  
  const handleUpdateStatus = async (status) => {
    if (status === "reject" && !selectedReason) {
      toast.error("⚠️ กรุณาเลือกเหตุผลก่อน Reject");
      return;
    }
  
    setLoading(true);
    try {
      const result = await Service.updateDocumentStatus(
        props.item?.SHOP_ID,  
        props.item?.TYPE,     
        status,               
        status === "reject" ? selectedReason : "" // ✅ ส่งค่า reasonid
      );
  
      if (result.success) {
        toast.success(result.message);
        props.onUpdate({
          ...props.item,
          STATUS: status === "reject" ? "R" : "",
          REMARK: status === "reject" ? selectedReason : ""
        });
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      toast.error("🚨 เกิดข้อผิดพลาดในการอัปเดตสถานะ");
    }
  
    setLoading(false);
  };
  

  return (
    <div className="row">
      <Modal show={showMd} size={'lg'} onHide={() => setShowMd(false)}
        style={{ zIndex: 99999 }}>
        <Modal.Header closeButton>
          <Modal.Title>ยืนยันการอัพโหลดรูป</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3 col-md-12">
            <Card className="col-12">
              <Card.Body>
                <div className="container" style={{ height: '28vh', width: '100%' }}>
                  {state?.b64 ? (
                    <img
                      className="rounded mx-auto d-block"
                      style={{ maxHeight: '100%', maxWidth: '100%' }}
                      src={state.b64}
                      alt="Preview"
                    />
                  ) : (
                    <p>⚠️ ไม่มีรูปที่เลือก</p>
                  )}
                </div>
              </Card.Body>
            </Card>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleUploadConfirm} disabled={!state?.b64}>
            ✅ ยืนยันอัพโหลดรูปนี้
          </Button>
        </Modal.Footer>
      </Modal>

      <div className="card card-primary card-outline col-12">
        <div className={isLoading ? 'overlay dark' : 'd-none'}>
          <ClockLoader color="#c4c4c4" size="20" />
        </div>
        <div className="card-body p-3">
          <div className="row">
            <div className="col-2">
              {props.item ? (
                <div key={'i0'} className="img-item">
                  <Avatar
                    style={{ borderRadius: 5, cursor: 'pointer' }}
                    sx={{ width: 56, height: 56 }}
                    src={props.item.DOC_PATH}
                    onClick={() => handleClick(0)} //
                  />
                </div>
              ) : (
                <img src={'https://localhost:7168/images/nopic.png'} />
              )}
            </div>
            <div className="col-10">
              <div className="custom-file">
                <div className="input-group mb-3">
                  <div className="input-group-prepend">

                    <span
                      className={
                        props.item
                          ? props.item.STATUS === 'R'
                            ? 'input-group-text bg-danger'
                            : props.item.STATUS === 'A'
                              ? 'input-group-text bg-success'
                              : 'input-group-text'
                          : 'input-group-text'
                      }
                    >
                      {/* fa-times fas fa-check*/}
                      <i
                        className={
                          props.item
                            ? props.item.STATUS === 'A'
                              ? 'fas fa-check'
                              : 'fas fa-minus'
                            : 'fas fa-minus'
                        }
                      />
                    </span>

                  </div>
                  <div className="custom-file">
                    <input
                      disabled={
                        props.item && props.item.STATUS === 'A' && !isAdmin  ? true : false
                      }
                      type="file"
                      onChange={(e) => {
                        selectImage(e);
                      }}
                      className="custom-file-input"
                      accept="image/*;capture=camera"
                      id="customFile"
                    />
                    <label className="custom-file-label" htmlFor="customFile">
                      {file ? file.name : 'เลือกรูปถ่าย'}
                    </label>
                  </div>

                  {isAdmin === true && (
                    <div className="d-flex justify-content-around mt-0">
                      <Select
                        placeholder={'เลือกสาเหตุ'}
                        options={[
                          { label: 'รูปไม่ชัด', value: 'BI' },
                          { label: 'รูปผิด', value: 'WI' }
                        ]}
                        // onChange={(v) => { }}
                          onChange={(v) => setSelectedReason(v.value)} // ✅ เก็บค่า reasonid
                      />
                      <Button className='ml-1' variant="danger" onClick={() => handleUpdateStatus("reject")} disabled={props.item && props.item.STATUS === 'A' ? true : false}>Reject</Button>
                      <Button className='ml-1' variant="warning" onClick={() => handleUpdateStatus("unshow")}>Unshow</Button>
                      {/* <Button variant="warning" onClick={() => handleUpdateStatus("edit")}>✏️ แก้ไข</Button> */}
                    </div>
                  )}
                </div>
              </div>
              <div style={{ color: 'red' }}>{props.item
                ? props.item.REMARK === 'WI'
                  ? 'รูปผิด'
                  : props.item.REMARK === 'BI' ? 'รูปไม่ชัด' : ''
                : ''}</div>
            </div>

          </div>
        </div>
      </div>
      {!!currentImage && (
        /* @ts-ignore */
        <Lightbox
          reactModalStyle={customStyles}
          mainSrc={currentImage.src}
          mainSrcThumbnail={currentImage.src}
          nextSrc={nextImage.src}
          nextSrcThumbnail={nextImage.src}
          prevSrc={prevImage.src}
          prevSrcThumbnail={prevImage.src}
          onCloseRequest={handleClose}
          onMovePrevRequest={handleMovePrev}
          onMoveNextRequest={handleMoveNext}
        />
      )}
    </div>
  );
}
